function toggle(revealerEl, display, unlockDelay = 10) {
    const content = revealerEl.querySelector('.js-revealer-content');
    const hideAtOpens = revealerEl.querySelectorAll('.js-revealer-hide-at-open');
    let displayVal = 'block';
    let displayCursor = 'default';
    if (revealerEl.classList.contains('js-revealer-flex')) displayVal = 'flex';
    if (revealerEl.classList.contains('js-revealer-grid')) displayVal = 'grid';
    if (revealerEl.classList.contains('js-revealer-pointer')) displayCursor = 'pointer';

    revealerEl.style.cursor = display ? displayCursor : 'pointer';
    content.style.display = display ? displayVal : 'none';
    hideAtOpens.forEach((hao) => { hao.style.display = display ? 'none' : 'inline-block'; });

    setTimeout(() => {
        content.style.pointerEvents = display ? 'auto' : 'none';
    }, unlockDelay);

    if (display) {
        revealerEl.classList.add('js-revealer-open');
        global.quietmark.truncate();
    } else {
        revealerEl.classList.remove('js-revealer-open');
    }
}

function revealer() {
    if (document.querySelector('.js-revealer')) {
        // ..

        document.querySelectorAll('.js-revealer').forEach((revealerEl) => {
            toggle(revealerEl, false);

            // hover by default unless js-revealer-click specified
            if (revealerEl.classList.contains('js-revealer-click')) {
                window.addEventListener('click', (e) => {
                    if (revealerEl === e.target || revealerEl.contains(e.target)) {
                        toggle(revealerEl, true);
                    } else {
                        toggle(revealerEl, false);
                    }
                });
            } else {
                revealerEl.addEventListener('mouseover', () => {
                    toggle(revealerEl, true);
                });
                revealerEl.addEventListener('mouseleave', () => {
                    toggle(revealerEl, false);
                });
            }

            window.addEventListener('tap', (e) => {
                if (revealerEl === e.target || revealerEl.contains(e.target)) {
                    if (!revealerEl.classList.contains('js-revealer-open')) {
                        e.preventDefault();
                    }
                    toggle(revealerEl, true, 150);
                } else {
                    toggle(revealerEl, false);
                }
            }, { passive: false });
        });
    }
}

revealer();

module.exports = revealer;
